<template lang="html">
  <v-flex
    pa-0
    class="no-print"
  >
    <div
      class="si-feedback-popup"
      :class="{'active': active}"
    >
      <v-card
        :max-width="$vuetify.breakpoint.smAndUp ? 350 : '100%'"
        :width="$vuetify.breakpoint.smAndUp ? 350 : '100%'"
        class=""
      >
        <v-card-title class="title pt-3 pb-0">
          {{ title }}
          <v-btn
            v-if="window === 2"
            text
            small
            color="grey lighten-1"
            @click="changeRating"
          >
            <v-layout
              align-center
              ma-0
            >
              {{ feedback.ratings.overall }} <v-icon
                small
                left
                class="ml-1"
              >
                star
              </v-icon><small>change</small>
            </v-layout>
          </v-btn>
          <v-spacer />
          <!-- <v-btn text small color="grey" @click="toggleMore"><v-icon>expand_more</v-icon>more </v-btn> -->

          <v-btn
            v-if="!close"
            text
            icon
            small
            @click="active = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-progress-circular
            v-if="close"
            :value="closeProgress"
            width="2"
            rotate="270"
            color="yellow darken-2"
            class="ma-0 si-close-progress"
          >
            <v-btn
              text
              icon
              small
              @click="closeMe"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-progress-circular>
        </v-card-title>
        <v-card-text class="pt-0 pb-3">
          <v-window
            v-model="window"
            vertical
          >
            <v-window-item
              key="0"
              class="white"
            >
              <v-flex
                pa-0
                text-center
              >
                <v-rating
                  v-model="feedback.ratings.overall"
                  :length="5"
                  half-increments
                  color="yellow darken-2"
                  background-color="yellow darken-2"
                  hover
                  largex
                />
                <v-btn
                  text
                  small
                  color="grey"
                  @click="toggleMore"
                >
                  <v-icon>expand_more</v-icon>more
                </v-btn>
              </v-flex>
            </v-window-item>

            <v-window-item
              key="1"
              class="white"
            >
              <v-flex
                xs12
                text-center
              >
                <v-btn
                  text
                  small
                  color="grey"
                  @click="toggleMore"
                >
                  <v-icon>expand_less</v-icon>less
                </v-btn>
              </v-flex>
              <v-layout
                wrap
                align-center
              >
                <v-flex
                  shrink
                  class="body-2"
                >
                  Overall
                </v-flex>
                <v-flex
                  grow
                  text-right
                >
                  <v-rating
                    v-model="feedback.ratings.overall"
                    :length="5"
                    half-increments
                    color="yellow darken-2"
                    background-color="yellow darken-2"
                    hover
                    largex
                  />
                </v-flex>
              </v-layout>
              <v-layout
                wrap
                align-center
              >
                <v-flex
                  shrink
                  class="body-2"
                >
                  Ease of use
                </v-flex>
                <v-flex
                  grow
                  text-right
                >
                  <v-rating
                    v-model="feedback.ratings.ease"
                    :length="5"
                    half-increments
                    color="yellow darken-2"
                    background-color="grey darken-"
                    hover
                    largex
                  />
                </v-flex>
              </v-layout>
              <v-layout
                wrap
                align-center
              >
                <v-flex
                  shrink
                  class="body-2"
                >
                  Quality of report
                </v-flex>
                <v-flex
                  grow
                  text-right
                >
                  <v-rating
                    v-model="feedback.ratings.report"
                    :length="5"
                    half-increments
                    color="yellow darken-2"
                    background-color="grey darken-"
                    hover
                    largex
                  />
                </v-flex>
              </v-layout>
              <v-form
                ref="form"
                class="mt-3"
              >
                <SiInputTextarea
                  v-model="feedback.text"
                  label="Your feedback..."
                  outlined
                />
                <SiInputText
                  v-model="feedback.email"
                  label="Email (optional)"
                  outlined
                  hide-details
                />
              </v-form>
              <v-layout
                ma-0
                mt-3
              >
                <v-spacer />
                <v-btn
                  text
                  color="yellow darken-4"
                  :disabled="[0, null].includes(feedback.ratings.overall)"
                  @click="submitFeedback"
                >
                  Submit
                </v-btn>
              </v-layout>
            </v-window-item>

            <v-window-item
              key="2"
              class="white"
            >
              <v-flex
                text-center
                class="headline"
              />
            </v-window-item>
          </v-window>
        </v-card-text>
      </v-card>
    </div>
  </v-flex>
</template>

<script>
import uniqid from 'uniqid'
import { isArray } from 'lodash'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import clientPath from '@/plugins/client-path'

export default {
  mixins: [ helpers ],
  props: {
    value: Boolean,
    savePath: [ String, Array ],
    for: {
      type: String,
      required: true
    },
    forId: {
      type: String,
      required: true
    },
    meta: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      window: 0,
      panels: [],
      dialog: false,
      active: false,
      title: `How'd we do?`,
      rating: 0,
      feedback: {
        ratings: {
          overall: null,
          ease: null,
          report: null
        },
        text: null,
        email: null
      },
      close: false,
      closeTimeout: null,
      closeProgress: 0
    }
  },
  computed: {
    // ...mapGetters([]),
  },
  watch: {
    value () {
      this.active = true
    },
    'feedback.ratings.overall' () {
      if (this.window === 0) {
        this.title = 'Thank you!'
        this.close = true
        this.window = 2
        this.closeTimeout = setTimeout(() => {
          this.submitFeedback()
        }, 7000)
        this.$nextTick(() => {
          this.closeProgress = 100
        })
      }
    }
  },
  methods: {
    changeRating () {
      clearTimeout(this.closeTimeout)
      this.close = false
      this.title = `How'd we do?`
      this.window = 0
      this.closeProgress = 0
    },
    closeMe () {
      if (this.feedback.ratings.overall > 0) this.submitFeedback(0)
      this.active = false
    },
    submitFeedback (timer = 2000) {
      let id = uniqid()
      let paths = this.savePath
      let updates = {}
      let feedbackPath = `feedback/ratings/${id}`
      let feedback = Object.assign({}, this.feedback, { id: id, for: this.for, forId: this.forId, meta: this.meta, timestamp: Number(new Date()) })
      this.title = 'Thank you!'
      this.window = 2

      this.closeTimeout = setTimeout(() => {
        this.active = false

        if (!isArray(paths)) paths = [paths]

        paths.forEach(p => {
          updates[`${p}/feedback`] = feedback
        })
        updates[feedbackPath] = feedback

        rtdb.ref().update(updates)
        clientPath.track(`feedback`, { id, type: 'feedback' })
      }, timer)
    },
    toggleMore () {
      this.window = this.window === 1 ? 0 : 1
    }
  }
}
</script>

<style lang="css">
.si-feedback-popup {
  position: fixed;
  width: 100%;
  z-index: 200;
  left: 0;
  bottom: 0;
  transform: translateY(100%);
  transition-property: all;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-delay: 0s;
}
.si-feedback-popup.active {
  transform: translateY(0);
}
.si-close-progress  .v-progress-circular__underlay {
  stroke: transparent
}
.si-close-progress  .v-progress-circular__overlay {
  transition-property: all;
  transition-duration: 10s;
  transition-timing-function: ease;
  transition-delay: 0s;
}

</style>
